/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CustomFontUploadPathParams,
	CustomFontUploadRequest,
	CustomFontUploadResponse,
} from '../types/CustomFontUpload'
import { buildFormData } from '../utils/form-data'

/**
 * POST /organisations/:organisation/fonts
 * @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::upload
 */
export async function customFontUpload(
	organisation: CustomFontUploadPathParams['organisation'],
	data: CustomFontUploadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFontUploadResponse>> {
	return axiosInstance.post(`/organisations/${organisation}/fonts`, buildFormData(data), {
		headers: { 'Content-Type': 'multipart/form-data' },
		...config,
	})
}
